// Angular Files
import { Component } from '@angular/core';

// Teller Online Library Files
import { TellerOnlineSiteMetadataService } from 'teller-online-libraries/core';

@Component({
    selector: 'app-footer',
    template: `
        <public-footer
            [preview]="false"
            [footerLinks]="siteMetadata?.customization?.footerLinksContent">
        </public-footer>
    `,
    // No host class here: the footer band is a global rule (.footer in styles/_chrome.scss) applied
    // to the inner <public-footer>. A 'footer' class on this wrapper would render the band twice.
    standalone: false
})
export class FooterComponent {
    constructor(
        public siteMetadata: TellerOnlineSiteMetadataService,
    ) {}
}
